export default "__VITE_ASSET__B6xTEYx___"